var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"variant":"faded","type":"light","id":"navbar"}},[_c('b-navbar-brand',{staticClass:"ml-auto mr-auto",attrs:{"href":"#"}},[_c('img',{attrs:{"src":"/static/maisoncannoise_logorectangle2.png","width":"300px","alt":"Kitten"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1909c237","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = null
// module chunks = 